
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextInput, Button,Breadcrumb,Search, Icon, Dropdown, Notification,Modal,Sidepanel, TextArea, DataTable, Popover, Switcher } from "pepsico-ds";
import { useForm, Controller,useWatch } from "react-hook-form";
import "./svc_account.css";
import axios from "axios";
import { useLoading } from "../../loader";
import Tooltip from "../landing/tooltip";
import forge from "node-forge";
import { toast,ToastContainer  } from 'react-toastify';
import { useEffect } from "react";
import PamNoData from "../../common/pam_no_data";
import { useNavigate } from "react-router-dom";

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsoZnlKyNcmMo3zrdx3KGc+/+fk1Jn7zYVyENg8hf6+SQ+p03Mzx8+hO6QUWgkJtlQfWBabZWMolGcpr37QTs4LJc6IEdvy24b8SjWM8AXj6II+SRpOR1m7W9I0eD16+6/nLWBpB5FAxCjrODC//BZVvGStXnTfQZc+/E2EamK21DneFkJaC9FlTwoNSy+LM5bjf6Q2YjWuX06uePzaAOLnycyhA8fHMoHwBQLdzfpKwRKMOr3VnDilem9RH9zGi44rg8y2g2TY1WzvsStmDM8NduV5aOnwzFMo+BTugfLhdP4ZmYR/BX5WLfPmxkAEI5fVNONBCuzoJsyX424wMLlwIDAQAB
    -----END RSA PUBLIC KEY-----`;
export const encrypt = (plainText, key) => {
  const publicKey = forge.pki.publicKeyFromPem(key);
  return forge.util.encode64(
    publicKey.encrypt(plainText, "RSA-OAEP", {
      md: forge.md.md5.create(),
      mgf1: {
        md: forge.md.sha1.create(),
      },
    })
  );
};

export const encryptAES = async (msg) => {
  const key = crypto.getRandomValues(new Uint8Array(16)); // 128-bit key
  const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV (recommended for AES-GCM)

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    key,
    { name: "AES-GCM" },
    true,
    ["encrypt"]
  );

  const encodedMsg = new TextEncoder().encode(msg);

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    encodedMsg
  );

  return {
    key: btoa(String.fromCharCode(...key)), // Convert to Base64 for storage
    iv: btoa(String.fromCharCode(...iv)),
    encrypted: btoa(String.fromCharCode(...new Uint8Array(encrypted))),
  };
};

const SvcAccountRequest = () => {
  const { t } = useTranslation();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showCreateNewSafe,setShowCreateNewSafe] = useState(false);
  const [accountNames,setAccountNames] = useState([]);
  const [userSvcData,setUserSvcData] = useState('');
  const [filteredUserSvcData, setFilteredUserSvcData] = useState([]);
  const [domains,setDomains] = useState([]);
  const [address,setAddress] = useState([]);
  const [platforms,setPlatforms] = useState([]);
  const [type,setType] = useState();
  const [passwordType, setPasswordType] = useState("password");
  const [rePasswordType,setRePasswordType] = useState("password");
  const [userDn,setUserDn] = useState([]);
  const { showLoader, hideLoader } = useLoading();
  const [loader, setLoader] = useState(false);
  const[userDnRequired,setUserDnRequired] = useState(false);
  const[showSidePanel,setShowSidePanel] = useState(false);
  const[showChangeOwnerSidePanel,setShowChangeOwnerSidePanel] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const[selectedAccount,setSelectedAccount] = useState('')
  const [users,setUsers] = useState([])
  const [applications,setApplications] = useState([]);
  const[safeMembers,setSafeMembers] = useState([]);
  const [safeOwners,setSafeOwners] =useState([]);
  const [existingSafeMembers,setExistingSafeMembers] = useState([]);
  const selectedGPID = useRef('')
  const [selectedUser,setSelectedUser] = useState('')
  const [selectedApp,setSelectedApp] = useState('')
  const [selectedGpid,setSelectedGpid] = useState('')
  const [searchText,setSearchText] = useState('')
  const [gpid,setGpid] = useState('')
  const [appSearchText,setAppSearchText] = useState('')
  const [icon, setIcon] = useState('visibility');
  const [reTypeIcon, setReTypeIcon] = useState('visibility');
  const [submitValidatePassword,setSubmitValidatePassword] = useState(false)
  const [prefixValue, setPrefixValue] = useState("AP");
  const [isPasswordValid,setIsPasswordValid]=useState(null);
  const [disableGpidSearch,setDisableGpidSearch] =useState(false);
  const [disableAppSearch,setDisableAppSearch]=useState(false);
  const [showRetireAccountModal,setShowRetireAccountModal] = useState(false);
  const [closeModal,setCloseModal] = useState(false);
  const [value1, setValue1] = useState("");
  // const [toggleFilter, setToggleFilter] = useState(false);
  // const [selectedAccountTypeFilter, setSelectedAccountTypeFilter] = useState([{ id: '1', displayText: "ALL", value: 'ALL' }]);
  const [searchInput, setSearchInput] = useState("")
  // const accountTypeOptions = [
  //   { id: '1', displayText: t("mypam.all"), value: 'ALL' },
  //   { id: '2', displayText: t("mypam.ad"), value: 'AD' },
  //   { id: '3', displayText: t("mypam.idx"), value: 'IDX' }
  // ];
  const [columns, setColumns] = useState(
    [
      { columnKey: "name", header: "Account Name", showColumnVisibility: true, initialSize:142 },
      { columnKey: "type", header: "Account Type",initialSize:120},
      { columnKey: "domain", header: "Domain",initialSize:100 },
      { columnKey: "address", header: "Address",initialSize:100},
      { columnKey: "action", header: "Action",initialSize:140, enableSorting: false, cellData: (ctx) => {
      return <>
        <Button
          className=""
          size="medium"
          style={{height:'auto',textAlign:"left"}}
          text="Onboard into myPAM"
          variant="tertiary"
          onClick={(e)=>{
            clickdRow(e, ctx.row.original,false)
          }}
          // onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
        />
        
          </> 
          }
      },
      { columnKey: "change", header: "Change",initialSize:155, enableSorting: false, cellData: (ctx) => {
          return <>
          
            <Button
              className=""
              size="medium"
              style={{height:'auto',textAlign:"left"}}
              text="Change Account Owner"
              variant="tertiary"
              onClick={(e)=>{
                clickdRow(e, ctx.row.original,true)
              }}
              // onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
            />
            </> 
              }
      }]
  );
  const switchItems = [
  { label: "ALL" },
  { label: "AD" },
  { label: "IDX" },
];

const [selectedSwitchIndex, setSelectedSwitchIndex] = useState(0);

    // const handleApplyFilter = () => {
    //   setToggleFilter(false);
    //   let filteredData = selectedAccountTypeFilter?.[0]?.value === "ALL" ? userSvcData : userSvcData.filter((rec)=>rec?.type === selectedAccountTypeFilter?.[0]?.value)
    //   if(searchInput){
    //     filteredData = filteredData.filter((rec)=>rec?.name?.toLowerCase?.()?.includes?.(searchInput?.toLowerCase?.()));
    //   }
    //   setFilteredUserSvcData(filteredData);
    // }
const handleAccountTypeFilter = (index) => {
  setSelectedSwitchIndex(index);

  const selectedType = switchItems[index].label;

  const filteredData =
    selectedType === "ALL"
      ? [...userSvcData]
      : userSvcData.filter(
          (item) =>
            item?.type?.trim()?.toUpperCase() === selectedType
        );

  console.log("Selected:", selectedType);
  console.log("Rows:", filteredData.length);

  setFilteredUserSvcData(filteredData);
};
  
    const [query, setQuery] = React.useState('');

    const debouncedSearch = useDebouncedCallback((q) => {
      // Enforce min 3 chars before hitting API
      if (q?.trimStart()?.length >= 3) {
        searchApplications(q);
      } else {
        setApplications([]);
      }
    }, 500);

    const [queryGPID, setQueryGPID] = React.useState('');
    const debouncedSearchGPID = useDebouncedCallback((q) => {
      // Enforce min 3 chars before hitting API
      if (q?.trim().length >= 3) {
        gpidSerach(q);
      } else {
        setUsers([]);
      }
    }, 2000);

  // const onRowSelectionChange = (e, user) => {
  //   e.stopPropagation();
  //   setSelectedRow(user);
  //   // selectedGPID.current = user.uid;
  // };
  const normalizeSel = (val) => (Array.isArray(val) ? val[0] ?? null : val ?? null);
  const PREFIX = "AP_";
  const userLang = localStorage.getItem("i18nextLng");
  const isArabic = userLang.startsWith('ar');
  // const handleChange = (e) => {
  //   let v = e.target.value;

  //   if (!v.startsWith(PREFIX)) {
  //   v = PREFIX + v.replace(PREFIX, "");
  // }

  //   setPrefixValue(v);
  // };

const clickOnRetireAccount = (e,row)=>{
  setSelectedAccount(row);
  setShowRetireAccountModal(true)
  // onSubmitRetireAccount(row);

}

useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

const clickdRow = (e,row,changeOwner)=>{
  console.log('111111111111',e);
  setSelectedAccount(row);
  setOtherValues(row,changeOwner);
  
}

const updateSearchText = (val) => {
  setSearchText(val);
};

const ValidatePassword =(values)=>{
  console.log('222222222222',selectedAccount);
  console.log('33333333333333',existingPassword);
  const data = JSON.parse(localStorage.getItem("okta-token-storage"));
  let userGpId = '';
  if (!gpid && data?.accessToken?.claims?.gpid) {
    userGpId = data?.accessToken?.claims?.gpid;
  }
  let encryptedPwd = encrypt(existingPassword, publicKey);
  let encryptedRetypePwd = encrypt(existingRetypePassword,publicKey)
  const payload = {
    principal:selectedAccount.name,
    existingPassword: encryptedPwd,
    retypePassword:encryptedRetypePwd,
    address: selectedAccount.address,
    domain: selectedAccount?.domain,
    typeOfAccount: selectedAccount?.type,
    userdn: selectedAccount?.userDn
  };
  setSubmitValidatePassword(true);
  axios.post(REACT_APP_API_ENDPOINT + "pam/validatePassword",
    payload
    ).then((response)=>{
      console.log('hello');
      if(response.data.status == "Failed"){
        toast.error("Password does not match "+ " "+ selectedAccount?.type +", please reach out to your team to obtain correct password.");
        setIsPasswordValid(false);
        setSubmitValidatePassword(false);
        hideLoader();
        setLoader(false);
      }
      else{
        toast.success("Password is verified Successfully!")
        setIsPasswordValid(true);
        setSubmitValidatePassword(false);
        hideLoader();
        setLoader(false);
      }
    }).catch((error)=>{
        hideLoader();
        setLoader(false);
        toast.error(error?.message)
        console.log('error', error);
  })
}

const updateAppSearchText = (val) => {
  setAppSearchText(val);
};

const [toasts, setToasts] = useState([]);
  const showToast = (index, message, type) => {
    setToasts([
      {
        id: `toast-${index}`,
        duration: 10000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const gpidSerach =(val) =>{
    console.log('2222222222222',typeof val);
    const isNumeric = (value) =>
      value !== "" && !isNaN(value) && !isNaN(Number(value));
    if (val.length < 3){
      return
    }
    showLoader();
    setDisableGpidSearch(true);
    setLoader(true);
    axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {  
     [isNumeric(val) ? "gpid" : "email"]: val,
     "fetchOnlyActiveUsers":true
      }).then((response)=>{
        console.log('hello');
        hideLoader();
        setDisableGpidSearch(false);
        setLoader(false);
        
        // Check for API error response
        if(response?.data?.status === "Failed"){
          toast.error(response?.data?.errorMessage || "An error occurred");
          setUsers([]);
          return;
        }
        
        if(!response?.data?.userData){
          toast.error("No users match your search criteria.")
          return;
        }  
        const mapped = Object.values(response?.data?.userData).map(item => ({
          id: item.uid,
          label: `${item.uid} - ${item.givenName} ${item.sn} - ${item.mail}`
        }));

        setUsers(mapped);
      }).catch((error)=>{
          hideLoader();
          setDisableGpidSearch(false);
          setLoader(false);
          setUsers([]);
          toast.error(error?.response?.data?.errorMessage || error?.message || "An error occurred");
          console.log('error', error);
    })
    }
  useEffect(()=>{
    setColumns([
        { columnKey: "name", header: "Account Name",initialSize:142 },
        { columnKey: "type", header: "Account Type",initialSize:100},
        { columnKey: "domain", header: "Domain",initialSize:100},
        { columnKey: "address", header: "Address",initialSize:105},
        { columnKey: "lastLogonDate", header: "Last Logon", initialSize:120},
        { columnKey: "lastPasswordSetDate", header: "Password Last Changed",initialSize:160},
        // { columnKey: "description", header: "Description",size:250},
        { columnKey: "onboard-action", header: " ", initialSize:140, enableSorting: false, cellData: (ctx) => {
        return <>
          <Button
            className=""
            size="small"
            iconLeading="person_add_alt_1"
            style={{height:'auto', fontWeight:"bold",wordBreak:"auto-phrase",textAlign:"left"}}
            text={ctx.row.original?.hasPendingRequest? "Request Inprogress" :"Onboard into myPAM"}
            variant="primary"
            onClick={(e)=>{
              clickdRow(e, ctx.row.original,false)
            }}
            disabled={!!ctx.row.original?.hasPendingRequest}
          />
  
          </> 
          }
          },
          { columnKey: "change-owner-action", header: "Action", initialSize:155, enableSorting: false, cellData: (ctx) => {
            return <>
              <Button
                className=""
                size="small"
                iconLeading="cached"
                style={{height:'auto', fontWeight:"bold",textAlign:"left",wordBreak:"auto-phrase"}}
                text="Change Account Owner"
                variant="secondary"
                onClick={(e)=>{
                  clickdRow(e, ctx.row.original,true)
                }}
                disabled={!!ctx.row.original?.hasPendingRequest}
              />
                </> 
          }},
          { columnKey: "retire-action", header: " ", initialSize:100, enableSorting: false, cellData: (ctx) => {
          return <>
            <Button
              className="retire-btn"
              size="small"
              iconLeading="delete"
              style={{height:'auto', fontWeight:"bold",textAlign:"left", color:"red",wordBreak:"auto-phrase"}}
              text="Retire Account"
              variant="tertiary"
              onClick={(e)=>{
                clickOnRetireAccount(e, ctx.row.original)
              }}
              disabled={!!ctx.row.original?.hasPendingRequest}
            />
            </> 
          }
    }])
  },[selectedRow]);
  const [safes,setSafes]= useState([]);
  const [environments,SetEnvironments] =useState([
    {
    id:'PR',displayText:'Production'
    },
    {
      id:'DV',displayText:'Development'
    },
    {
      id:'IT',displayText:'Integrated Test'
    },
    {
      id:'QA',displayText:'Quality Assurance'
    },
    {
      id:'PP',displayText:'Pre-Production'
    }
  ])
  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { isValid, isSubmitting, errors },
    watch,
  } = useForm({
    defaultValues:{
      mode: 'onChange',
      reValidateMode: 'onChange',
      safeName: null,
      fullAppName:null,
      existingPassword: '',
      existingRetypePassword: '',
      // appName:'',
      environment:'',
      // teamname:''

    }
  });

  const appName = watch("appName");
  const environment = watch("environment");
  const teamname = watch("teamname");

  const existingPassword = watch('existingPassword');
  
  const existingPasswordValue = useWatch({
    control,
    name: "existingPassword",
  });

  const existingRetypePassword = watch('existingRetypePassword');
  const getUserSvcDetails = () => {
    let usersvcdata = [];
    let res = usersvcdata;
    setUserSvcData(usersvcdata?.svcAccounts);
    setFilteredUserSvcData(usersvcdata?.svcAccounts);
    // showLoader();
    // setLoader(true);
    // axios
    //   .get(REACT_APP_API_ENDPOINT + "pam/fetchUserAccounts", {
    //   })
    //   // .then(response => response.json())
    //   .then((response) => {
    //     console.log('99999999999',response);
        
    //     if(response?.data?.status == "Failed"){
    //       // toast.error(response?.data?.errorMessage);
    //       setUserSvcData([]);
    //       setFilteredUserSvcData([])
    //       hideLoader();
    //       setLoader(false);
    //     }
    //     else{
    //       // toast.success("SVC account data fetched successfully.");
    //       let usersvcdata = response?.data;
    //       let res = usersvcdata;
    //       setUserSvcData(usersvcdata?.svcAccounts);
    //       setFilteredUserSvcData(usersvcdata?.svcAccounts)
    //       // const svcNames = res?.svcAccounts.map((acc, i) => ({
    //       //   id: acc.name || `unnamed_${i}`,       // fallback if name missing
    //       //   displayText: acc.name + '-' +acc.type || `Unnamed #${i}`
    //       //   }));
    //       //   setAccountNames(svcNames);
    //       const svcSafes = res?.safes?.map((acc,i)=>({
    //         id: acc,       // fallback if name missing
    //         displayText: acc || `Unnamed #${i}`
    //       }));
    //       setSafes([{ id: "create_new", displayText: "Create new" }, ...svcSafes]);
    //       hideLoader();
    //       setLoader(false);
    //     } 
        
    //   })
    //   .catch((error) => {
    //     hideLoader();
    //     setLoader(false);
    //     setUserSvcData([]);
    //     console.error("Error fetching data:", error);
    //     return '';
    //   });
  };
  useEffect(() => {
    getUserSvcDetails();
  }, []);

  const handleToggle = () => {
    setPasswordType((prevType) => {
      const isPassword = prevType === "password";
      setIcon(isPassword ? "visibility_off" : "visibility");
      return isPassword ? "text" : "password";
    });
  };

  const handleToggleRetypePassword = () =>{
    if (rePasswordType === "password") {
      setReTypeIcon('visibility_off');
      setRePasswordType("text");
    } else {
      setReTypeIcon('visibility');
      setRePasswordType("password");
    }
  }
  
  const setOtherValues = (opt,changeOnwer) => {
    changeOnwer ? setShowChangeOwnerSidePanel(true):setShowSidePanel(true) ;
    console.log("setOtherValues opt:", opt);
    let sel;
    if(opt){
      sel = opt;
      // let accType = sel.displayText.split('-');
      if(sel.type == 'AD'){
        setUserDnRequired(false);
      }
      else{
        setUserDnRequired(true);
      }
    }
    else{
      setDomains([]);
      setAddress([]);
      setPlatforms([]);
      setType([]);
      setUserDn('');
      setValue("domain", [], { shouldValidate: true, shouldDirty: true });
      setValue("type", [], { shouldValidate: true, shouldDirty: true });
      setValue("address", [], { shouldValidate: true, shouldDirty: true });
      setValue("platform", [], { shouldValidate: true, shouldDirty: true });
      setValue("userDn", '',{ shouldValidate: true, shouldDirty: true })
      return;
    }

    // if (!sel) return;

    const accounts = opt ?? [];
    // if (!Array.isArray(accounts) || accounts.length === 0) return;
    console.log('2222222222222',accounts);
    
    // const accIndex = accounts.findIndex((a) => a?.name === sel.id);
    // console.log('33333333333333333333',accIndex);
    
    if (!accounts) {
      console.warn(`No account found for name "${sel.id}"`);
      // Clear dependent values if no match
      setDomains([]);
      setAddress([]);
      setPlatforms([]);
      setType([]);
      setUserDn('');
      setValue("domain", [], { shouldValidate: true, shouldDirty: true });
      setValue("type", [], { shouldValidate: true, shouldDirty: true });
      setValue("address", [], { shouldValidate: true, shouldDirty: true });
      setValue("platform", [], { shouldValidate: true, shouldDirty: true });
      setValue("userDn", { shouldValidate: true, shouldDirty: true })
      return;
    }

    const acc = accounts;
    const typeTxt = acc.type
    const accountOpt ={
      id: acc.name,
      displayText: acc.name,
    };
    const accountType ={
      id: acc.type,
      displayText: acc.type,
    };
    const domainOpt = {
      id: acc.domain,
      displayText: acc.domain,
    };
    const addressOpt = {
      id: acc.address,
      displayText: acc.address,
    };
    const platformOpt = {
      id: acc.platform,
      displayText: acc.platform,
    };

    // Update option lists shown by the Domain/Address/Platform dropdowns
    setAccountNames([accountOpt])
    setDomains([domainOpt]);
    setAddress([addressOpt]);
    setPlatforms([platformOpt]);
    setType([accountType])

    // Programmatically set the selected values in the form (RHF)
    setValue("accountName", [accountOpt]);
    setValue("domain", [domainOpt]);
    setValue("type", [accountType]);
    setValue("address", [addressOpt]);
    setValue("platform", [platformOpt]);
    
    // Optionally set userDn if provided
    if (acc.userdn) {
      setUserDn('');
      console.log('4444444444444444',acc.userdn);
      setUserDn(acc.userdn)
      setValue("userDn", [acc.userdn]);
    }
    
  };
 
  // normalize to string id for payload
  const toId = (v) => {
    if (v == null) return "";
    if (typeof v === "string") return v;
    return v.id ?? "";
  };

  const resetAllForm = () =>{
    setSelectedAccount([]);
    setApplications([]);
    setUsers([]);
    setQueryGPID('');
    setIsPasswordValid(null);
    setSafeMembers([]);
    setSafeOwners([]);
    setShowCreateNewSafe(false);
    reset();
  }

  const onSubmit = (values) => {
    console.log('44444444444444444',values);
    const missingIds = existingSafeMembers
    .map(m => m.id)
    .filter(id => !new Set(safeMembers.map(x => x.id)).has(id));

    const addedIds = safeMembers
    .map(m => m.id)
    .filter(id => !new Set(existingSafeMembers.map(x => x.id)).has(id));
    console.log('2312132122',missingIds,addedIds);
    const parts = String(values?.fullAppName.id).split('-');
    const selectedAppName = parts[parts.length - 1];
    // return;
    let encryptedPwd = encrypt(values.existingPassword, publicKey);
    const isNewSafe = values?.safeName[0].id === 'create_new'? true : false
    const payload = {
      svcAccountName: values?.accountName[0]?.id,
      applicationName:selectedAppName,
      type: values?.type[0]?.id,
      domain: values?.domain[0]?.id,
      address: values?.address[0].id,
      userdn: values?.userDn ? values?.userDn[0] :'',
      platform: values?.platform[0].id,
      safeName: isNewSafe ? 
      (
        `${prefixValue ?? ""}_${environment?.[0]?.id ?? ""}_${appName ?? ""}${
          teamname ? `_${teamname}` : ""
        }`
      ).toUpperCase()
       : values?.safeName[0].id,
      appShortName:values?.appShortName,
      isNewSafe:isNewSafe,
      safeMembers: addedIds,
      removeSafeMembers:missingIds,
      secret: encryptedPwd,
    };

    console.log("Submitting:", payload);
    // return;
    showLoader();
    setLoader(true);
    axios
      .post(REACT_APP_API_ENDPOINT + "/pam/submitAccount", 
        payload
      )
      // .then(response => response.json())
      .then((data) => {
        let usersvcdata = data?.data;
        if(usersvcdata?.status == 'Failed'){
          toast.error(usersvcdata?.errorMessage);
          resetAllForm();
          getUserSvcDetails();
          hideLoader();
          setLoader(false);
          reset();
          setShowSidePanel(false);
        }
        else{
          toast.success(usersvcdata?.message);
          resetAllForm();
          getUserSvcDetails();
          setShowSidePanel(false);
          hideLoader();
          setLoader(false);
        }
      })
      .catch((error) => {
        toast.error(error?.message)
        hideLoader();
        setLoader(false);
        console.error("Error fetching data:", error);
        return '';
      });
  };

  const onSubmitRetireAccount = (values)=>{
    console.log('1111111111',values);
    
    const payload = {
      svcAccountName: values?.name,
      domain: values?.domain,
      accountType: values?.type,
    };
    console.log("Submitting:", payload);
    // return;
    showLoader();
    setLoader(true);
    axios
      .post(REACT_APP_API_ENDPOINT + "pam/decommissionAccount", 
        payload
      )
      // .then(response => response.json())
      .then((data) => {
        let usersvcdata = data?.data;
        console.log("hello",usersvcdata);
        console.log('233232323',);
        
        if(userSvcData?.status == 'Failed'){
          setShowRetireAccountModal(false);
          toast.error(userSvcData.errorMessage);
          getUserSvcDetails();
          // reset();
          hideLoader();
          setLoader(false);
        }
        else{
          setShowRetireAccountModal(false);
          toast.success(usersvcdata?.message);
          getUserSvcDetails();
          hideLoader();
          setLoader(false);
          // reset();
        }
      })
      .catch((error) => {
        toast.error(error?.message)
        hideLoader();
        setLoader(false);
        console.error("Error fetching data:", error);
        return '';
      });
}

  const onSubmitChangeOwner = (values)=>{
      console.log('1111111111',values);
      const parts = String(values?.ownerGpid?.id).split('-');
      const selectedGpid = parts[parts.length - 1];
      const payload = {
        svcAccountName: values?.accountName[0]?.id,
        domain: values?.domain[0]?.id,
        accountType: values?.type[0]?.id,
        address: values?.address[0]?.id,
        userdn: values?.userDn,
        platform: values?.platform[0]?.id,
        newOwnerGpid: selectedGpid,
      };
      console.log("Submitting:", payload);
      
      showLoader();
      setLoader(true);
      axios
        .post(REACT_APP_API_ENDPOINT + "pam/changeAccountOwner", 
          payload
        )
        // .then(response => response.json())
        .then((data) => {
          let usersvcdata = data?.data;
          if(userSvcData?.status != 'Failed'){
            toast.success("Thank you for submitting the request for service account ownership change");
            getUserSvcDetails();
            reset();
            hideLoader();
            setLoader(false);
            setShowChangeOwnerSidePanel(false);
          }
          else{
            toast.error(usersvcdata?.errorMessage);
            getUserSvcDetails();
            hideLoader();
            setLoader(false);
            reset();
            setShowChangeOwnerSidePanel(false);
          }
        })
        .catch((error) => {
          toast.error(error?.message)
          hideLoader();
          setLoader(false);
          console.error("Error fetching data:", error);
          return '';
        });
  }

  const onClickSelect = () => {
    let statePayload = {};
    console.log('111111111111',selectedRow);
    
    if (selectedRow) {
      
      setShowSidePanel(true);
    }
  }
  const clearUsers =()=>{
    setUsers([]);
    setQueryGPID('');
  }
  const onClickCancel = () => {
      // navigate('/myidmPortal')
  }
 
  // const searchApplications = (text) =>{
  //   showLoader();
  //   axios.post(REACT_APP_API_ENDPOINT + "pam/getApplicationList", {
  //   'appFilter' : text
  //   }).then((response)=>{
  //     console.log('22222222222222',response);
  //     const mapped = Object.values(response?.data?.appList).map(item => ({
  //       id: item,
  //       label: item
  //     }));
  //     setApplications(mapped);
  //     hideLoader();
  //   }).catch((error)=>{
  //       hideLoader();
  //       console.log('error', error);
  // })
  // }

  
const searchApplications = async (text: string) => {
  if (!text || text?.trimStart()?.length < 3) {
    // Optional: guard min length here too
    setApplications([]);
    return;
  }
  try {
    showLoader();
    setDisableAppSearch(true);
    setLoader(true);
    const response = await axios.post(
      `${REACT_APP_API_ENDPOINT}pam/getApplicationList`,
      { appFilter: text?.trimStart() }
    );
    if(response?.data?.appList?.length == 0){
      toast.error("No applications match your search criteria.")
    }
    const list = response?.data?.appList ?? {};
    const mapped = Object.values(list).map((item: string) => ({
      id: item,
      label: item,
    }));
    setApplications(mapped);
    hideLoader();
    setDisableAppSearch(false);
    setLoader(false);
  } catch (error) {
    toast.error(error.message)
    console.log('error', error);
    hideLoader();
    setDisableAppSearch(false);
    setLoader(false);
  } finally {
    hideLoader();
    setDisableAppSearch(false);
    setLoader(false);
  }
};


  function useDebouncedCallback(callback, delay = 1000) {
    const timerRef = React.useRef();

    const debounced = React.useCallback((...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);

    // Cleanup to avoid calling setState after unmount
    React.useEffect(() => {
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };
    }, []);

    return debounced;
  }

  const openEmailDL = () =>{
    
  }
  
  const addToSafeMembers = (val) => {
    if (!val?.id) return;
  
    const parts = String(val.id).split('-');
    const selectedGpid = parts[parts.length - 1];
  
    if (!selectedGpid) return;
  
    const memberToAdd = { ...val, id: selectedGpid };
  
    setSafeMembers((prev) =>
      prev.some((item) => item.id === selectedGpid)
        ? prev
        : [...prev, memberToAdd]
    );
  };

  const removeFromSafeMembers =(gpidToRemove) =>{
    setSafeMembers(prev => prev.filter(item => item?.id !== gpidToRemove));
  }

  const getExistingSafeMembers = (val) =>{
    showLoader();
    setLoader(true);
    console.log('121121212',val);
    
    const payload ={
      safeCn:val[0]?.id
    }
    axios.post(REACT_APP_API_ENDPOINT + "pam/fetchSafeMembers",payload)
      .then((response) => {
        console.log('99999999999',response);
        
        if(response?.data?.status == "Failed"){
          toast.error(response?.data?.errorMessage);
          hideLoader();
          setLoader(false);
        }
        else{
          // toast.success("SVC account data fetched successfully.");
          let usersvcdata = response?.data;
          let res = usersvcdata?.members;
          let owners = usersvcdata?.owners;
          const mapped = res.map(item => ({
            id: item,
            label: item
          }));
          const mappedOwners = owners.map(item => ({
            id: item,
            label: item
          }));
          console.log(mapped);
          setSafeOwners(mappedOwners);
          setSafeMembers(mapped);
          setExistingSafeMembers(mapped);
          hideLoader();
          setLoader(false);
        } 
        
      })
      .catch((error) => {
        hideLoader();
        setLoader(false);
        console.error("Error fetching data:", error);
        return '';
      });

  }

  const makeSetSelectedValue = (onChange) => (opt) => {
    console.log('2222222222222',opt);
    setShowCreateNewSafe(false);
    if(opt && opt[0]?.id=='create_new'){
      setShowCreateNewSafe(true);
    }
  };

  return (
    <div>
      <div className="svc-account-page">
      <Breadcrumb
        homeIcon={{
          icon: "home",
          onClick:()=>{
            navigate("/home")
          }
        }}
        breadcrumbs={[
          {
            label: "Home",
          },
          {
            label: <div onClick={()=>{
              navigate("/pam-svc-account")
            }}>myPAM Service Account Onboarding Request</div>
          },
        ]}
        className="ml-3"
        onClick={function Xs() {}}
        useAnchor
        style={{ marginBottom: "1rem !important",width:"96%" }}
      /> 
      </div>
      <div
        className={isMobile ? "row" : "container"}
        style={{
          background: "none",
          boxShadow: "none",
          justifyContent: isMobile ? "center" : "",
        }}
      >
        
        <div
          style={{
            width:"100%",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "0px" : "15px",
            flexWrap: "wrap",
            flex: 1,
          }}
        >
          
          {/* Left Section */}
          {userSvcData && userSvcData?.length > 0 && 
          <div className={isMobile ? "row mt-2" : ""} style={{justifyContent:isMobile?"center":""}}>
          <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex mb-0'}  align-items-center`} style={{justifyContent:'space-between'}}>
            <h4 className={`${isMobile ? 'mb-2' : 'mbn'}`}>{"myPAM Service Account Onboarding Request"}</h4>
            <div className="hello">
            <Notification
              className=""
              primaryActionLabel="Email DL"
              primaryActionOnClick={() => {
                window.location.href = "mailto:ITmyPAMSupport@pepsico.com"
              }}
              showActionButtons
              showIcon ="mail"
              showText
              showTitle
              style={{marginBottom:"-10px",textAlign:"left !important",borderRadius: "var(--Semantic-Corner-Radius-Container-Large, 8px)",padding:"5px",
                border: "1px solid var(--Semantic-Feedback-Info-High-Contrast, #0755AA)",
                background: "var(--Semantic-Feedback-Info-Background, #E8F0FB)"}}
              text={"Need Assistance or have any Questions?"}
              title=""
              type="info"
            />
            </div>
          </div>
          <div
            className="card card-layout reg-card mb-3 mb-md-0"
            style={{
              flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <div className="card-content align-items-center">
              
                <div className="request-new-access-for-others-main-content h-100 m-0" style={{width:'100% !important'}}>
                  <div className="search-result"></div>
                  <div className="pam-safe-header d-md-flex justify-content-between">
                      <div
                          style={{
                              alignItems: 'center',
                              display: 'flex',
                              position: 'relative'
                          }}
                          >
                           
<Switcher
  items={switchItems}
  selectedItemIndex={selectedSwitchIndex}
  size="medium"
  variant="default"
  onUpdate={(newSelectedIndex) => {
    console.log("Switcher clicked:", newSelectedIndex);
    handleAccountTypeFilter(newSelectedIndex);
  }}
/>

                          {/* <Button
                              onClick={()=>setToggleFilter((prev)=>!prev)}
                              text={t("auditRequest.filter")}
                              variant="secondary"
                              className="filter-btn togglt-filter m-0"
                              size="small"
                              iconLeading="filter_alt"
                              style={{}}
                          />
                          <div
                              style={{
                              padding: '15px 0',
                              position: 'absolute',
                              top: '90%',
                              left: '195%'
                              }}
                              className="popover-container"
                          >
                              <Popover
                              badgeValue=""
                              className=""
                              direction="top-left"
                              onClosePopover={()=>setToggleFilter(false)}
                              showSlot
                              showPopover={toggleFilter}
                              style={{}}
                              text={t("auditRequest.filter")}
                              >
                                  <Dropdown
                                      childList={accountTypeOptions}
                                      label={t("mypam.account_type")}
                                      placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                      isClearable={false}
                                      selection="single"
                                      size="medium"
                                      setSelectedValue={(selected) => setSelectedAccountTypeFilter(selected)}
                                      selectedValue={selectedAccountTypeFilter}
                                      onKeyDown={(e) => e.preventDefault()}
                                      showLabelIcon={false}
                                      style={{gap: ".5rem", marginBottom: ".5rem"}}
                                  />
                                  <div className="d-flex justify-content-between mt-3">
                                      <div style={{
                                          fontSize: "12px",
                                          fontWeight: "500",
                                          display: "flex",
                                          alignItems: "center"
                                          }}>{`${selectedAccountTypeFilter?.length>0 ? 1 : 0} ${t("auditRequest.filter_selected")}`}</div>
                                      <div className="d-flex" style={{gap: ".5rem"}}>
                                          <Button
                                              onClick={()=>setToggleFilter(false)}
                                              text={t("auditRequest.cancel_label")}
                                              variant="tertiary"
                                              className="filter-btn"
                                              size="small"
                                              style={{fontWeight: "bold"}}
                                          />
                                          <Button
                                              onClick={handleApplyFilter}
                                              text={t("auditRequest.apply_filter")}
                                              variant="primary"
                                              className="filter-btn"
                                              size="small"
                                              disabled={!selectedAccountTypeFilter?.length}
                                          />
                                      </div>
                                  </div>
                              </Popover>
                          </div> */}
                      </div>
                      <div className="search-guest-record d-flex" style={{gap: "1rem"}}>
                          <Search
                              isClearable={searchInput?.length>0}
                              menuPosition="bottom-right"
                              // onClear={() =>{
                              //   const filteredData = selectedAccountTypeFilter?.[0]?.value === "ALL" ? userSvcData : userSvcData.filter((rec)=>rec?.type === selectedAccountTypeFilter?.[0]?.value)
                              //   setFilteredUserSvcData(filteredData);
                              // }}
                              onClear={() => {
  setSearchInput("");

  const selectedType = switchItems[selectedSwitchIndex].label;

  const filteredData =
    selectedType === "ALL"
      ? userSvcData
      : userSvcData.filter(
          (rec) => rec?.type?.toUpperCase() === selectedType
        );

  setFilteredUserSvcData(filteredData);
}}
                              // onSearch={() => {
                              //   const filteredData = searchInput ? filteredUserSvcData.filter((rec)=> rec?.name?.toLowerCase?.()?.includes?.(searchInput?.toLowerCase?.())) : selectedAccountTypeFilter?.[0]?.value === "ALL" ? userSvcData : userSvcData.filter((rec)=>rec?.type === selectedAccountTypeFilter?.[0]?.value);
                              //   setFilteredUserSvcData(filteredData);
                              // }}
                              onSearch={() => {
  const selectedType = switchItems[selectedSwitchIndex].label;

  let filteredData =
    selectedType === "ALL"
      ? userSvcData
      : userSvcData.filter(
          (rec) => rec?.type?.toUpperCase() === selectedType
        );

  if (searchInput) {
    filteredData = filteredData.filter((rec) =>
      rec?.name?.toLowerCase()?.includes(searchInput.toLowerCase())
    );
  }

  setFilteredUserSvcData(filteredData);
}}
                              onSelectOption={function oFe() { }}
                              // onUpdate={(e) =>{
                              //     setSearchInput(e);
                              //     if(!e){
                              //       const filteredData = selectedAccountTypeFilter?.[0]?.value === "ALL" ? userSvcData : userSvcData.filter((rec)=>rec?.type === selectedAccountTypeFilter?.[0]?.value);
                              //       setFilteredUserSvcData(filteredData);
                              //     }
                              // }}
                              onUpdate={(value) => {
  setSearchInput(value);

  if (!value) {
    const selectedType = switchItems[selectedSwitchIndex].label;

    const filteredData =
      selectedType === "ALL"
        ? userSvcData
        : userSvcData.filter(
            (rec) => rec?.type?.toUpperCase() === selectedType
          );

    setFilteredUserSvcData(filteredData);
  }
}}
                              delay={0}
                              placeholderText={t("mypam.search_by_account_name")}
                              size="medium"
                              style={{maxWidth:"revert", minWidth: "17rem"}}
                              value={searchInput}
                          />
                          <Button
                            className=""
                            size="small"
                            iconLeading="download"
                            style={{height:'auto', fontWeight:"bold",textAlign:"left",wordBreak:"auto-phrase"}}
                            text={t("mypam.export_as_CSV")}
                            variant="secondary"
                            onClick={async()=>{
                              try {
                                const response = await axios.get(REACT_APP_API_ENDPOINT + "pam/exportUserAccounts", {
                                  responseType: "blob",
                                });

                                const blob = new Blob([response.data], { type: "text/csv" });
                                const url = window.URL.createObjectURL(blob);

                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute("download", "myPAM_Service_Account_Onboarding_Request.csv");
                                document.body.appendChild(link);
                                link.click();

                                link.parentNode.removeChild(link);
                                window.URL.revokeObjectURL(url);
                              } catch (error) {
                                console.error("Error downloading the file:", error);
                              }
                            }}
                          />
                      </div>
                  </div>
                  <DataTable
                      className="datatable"
                      columns={columns}
                      enableSorting={true}
                      data={filteredUserSvcData}
                      pageIndex={0}
                      pageSize={10}
                      // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                      selection="single"
                      tableHeader="Data table header"
                      size="large"
                      showTableHeader ={true}
                      showTitle={true}
                      showSearchOption={false}
                      showColumnFilters={false}
                      showDescription={false}
                      tableDescription=""
                      showPagination={true}
                  /> 
                
              </div>
            </div>
          </div>
          </div>} 
          {((!userSvcData || userSvcData.length === 0) && !loader) && 
            <PamNoData 
              supportMail="ITmyPAMEngineering@pepsico.com"
            />
          }
        </div>
      </div>
      {/* <div>
        <p className="mr-3 mb-1 mt-0" style={{textAlign:'center',fontSize:"14px"}}>Any questions, please reach out to DL - myPAMEngineering@pepsico.com</p>
      </div> */}
    <div>
      <Modal
      id="actionModal"
      className="Session-expire-modal"
      onCloseModal={closeModal}
      closeOnOutsideClick={false}
      hideCloseButton={true}
      showModal={showRetireAccountModal}
      style={{}}
      showAuxiliaryButton={false}
      showPrimaryButton={true}
      showSecondaryButton={true}
      secondaryButtonProps={{
        onClick: () => {
          setShowRetireAccountModal(false)
        },
        size: 'medium',
        text: 'Cancel',
        variant: 'primary'
      }}
      primaryButtonProps={{
        
        onClick: () => {
          onSubmitRetireAccount(selectedAccount);
        },
        size: 'medium',
        text: 'Continue',
        variant: 'secondary'
      }}
      auxiliaryButtonProps={false}
      tertiaryButtonProps={false}
      title="Decommission Account"
      titleIcon=""
      text={`Are you sure you want to decommission this [${selectedAccount?.domain} / ${selectedAccount?.name}] Account?`}
      />
    </div>
    <div>
  <Sidepanel
    className=""
    linkProps={{
      iconLeading: '',
      iconTrailing: 'arrow_forward',
      label: 'Link',
      onClick: function ERe(){},
      size: 'medium'
    }}
    onCloseSidePanel={(event)=>{console.log('1212121212',event);
      if(event.type == 'mousedown' || event.type == "mouseup"){
        event.preventDefault();
        return;
      }
      resetAllForm();setShowSidePanel(false)}}
    primaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Submit',
      variant: 'primary'
    }}
    
    showSidePanel={showSidePanel}
    secondaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Cancel',
      variant: 'secondary'
    }}
    showFooter = {false}
    showLink ={false}
    showSecondaryButton
    showTertiaryButton ={false}
    style={{}}
    closeOnOutsideClick={false}
    tertiaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Button',
      variant: 'tertiary'
    }}
    title={"Account Name : " + accountNames[0]?.displayText + "[" + domains[0]?.displayText + "]"}
    type="vertical"
    verticalSidepanelHeight="40% !important"
  >
    <form
      className="form-size pro-form pb-3"
      onSubmit={handleSubmit(onSubmit,(errs) => {
          console.warn('Submit blocked by validation:', errs);
        })}
    >
      <div className="form-grid"> 
        {/* User DN */}
        {/* {userDnRequired && 
        <div className="form-field">
          <TextArea
            label={t("User DN")}
            placeholder={t("User DN")}
            showCharacterCount
            showToolbar={false}
            showLabelIcon={false}
            required={userDnRequired}
            {...register("userDn", {
              required: t("User DN is required"),
              minLength: { value: 3, message: t("User DN is too short") },
            })}
            aria-invalid={!!errors.userDn}
            helperText={errors.userDn?.message ?? ""}
            className=""
            style={{ width: "100%" }}
            value ={userDn}
          />
        </div>
        } */}
        {selectedAccount?.description?.length > 0 &&
        <div className="form-field">
        <TextArea
          label={t("Description")}
          value={selectedAccount?.description}
          readOnly={true}
          showCharacterCount
          showToolbar={false}
          showLabelIcon={false}
          className=""
          style={{ maxWidth: "100%",opacity: "0.6" }}
        />
        </div>
        } 
        {/* Safe Name */}
        <div className="form-field">
        <Controller
          name="safeName"
          control={control}
          
          rules={{
            required: t('Safe Name is required'),
            minLength: {
              value: 8,
              message: t('Enter 8 digits')
            }
          }}
          render={({ field, fieldState }) => (
            <Dropdown
              childList={safes}
              label={t('Safe Name')}
              selection="single"
              isClearable
              isRequired
              menuPosition="bottom-right"
              showLabelIcon={false}
              size="medium"
              selectedValue={field.value}
              // If your Dropdown exposes setSelectedValue, bridge it to RHF:
              setSelectedValue={(val) => {
                field.onChange(val);     
                // makeSetSelectedValue(sel); 
                setSafeMembers([]);
                setSafeOwners([]);
                setShowCreateNewSafe(Boolean(val && val[0].id === 'create_new'));
                if(val && val[0].id != 'create_new'){
                  getExistingSafeMembers(val);
                }
              }}

              // Nice-to-have wiring if supported by your component:
              onBlur={field.onBlur}
              inputRef={field.ref}

              // Show validation message from RHF:
              helperText={fieldState.error?.message ?? ''}
              isInvalid={!!fieldState.error}
              className="safe-name-dropdown"
              placeholder="Select Safe Name"
              onKeyDown={(e) => e.preventDefault()}
            />
          )}
        />
        </div>
        
        {showCreateNewSafe && (
          <>
            {/* New Safe (conditional) */}
            <div className="form-field" style={{marginBottom:"0px",marginTop:"0.25rem"}}>
              {/* <div style={{marginBottom:"-13px"}}>
              
               <span className="safe-name" title="This will be auto populated based on the selection below." style={{display:"flex",alignItems:"center"}}>New Safe
                <Icon
                  alt="alt value"
                  className="icon $color-icon small material-icons-outlined ml-1"
                  icon="info"
                  size="small"
                  style={{fontSize:"12px"}} />
                </span>    
            </div> */}

            <Controller
            name="newSafe"
            control={control}
            rules={{
              // required: t('New Safe name is required'),
              maxLength: {
                value: 28,
                message: "Maximum 19 characters allowed"
              }
            }}
            render={({ field, fieldState }) => (

              <div style={{ width: "100%" }}>
              <div
                className="safe-name d-flex align-items-center"
                title="This will be auto populated based on the selection below."
                style={{ gap: "6px", marginBottom: "-14px" }}
              >
                <span>New Safe</span>
                <Icon
                  alt="Info"
                  className="icon $color-icon small material-icons-outlined"
                  icon="info"
                  size="small"
                  style={{ fontSize: "12px" }}
                />
              </div>

              <TextInput
                type="text"
                className="input-margin-top-bottom-0"
                label=""                 //keep empty or omit if allowed
                value={(
                  `${prefixValue ?? ""}_${environment?.[0]?.id ?? "<environment>"}_${appName ?? "<App Name>"}`
                ).toUpperCase()}
                disabled
                maxLength={19}
                isClearable={false}
                required
                onPaste={(e) => e.preventDefault()}
                helperText={fieldState.error?.message ?? ""}
                style={{ width: "100%" }}
              />
            </div>
            )}
            />
            </div>

            <div className="form-field">
            <div>
              <label className="safe-name"><span title="E.g. Production is PR, Development is DV" style={{display:"flex",alignItems:"center"}}>Environment <Icon
                alt="alt value"
                className="$color-icon-default ml-1"
                icon="info"
                size="small"
                style={{fontSize:"12px"}} /></span></label>
            </div>
            <Controller
              name="environment"
              control={control}
              defaultValue=""
              rules={{
                required: t('Environment is required'),
              }}
              render={({ field, fieldState }) => (
                <Dropdown
                  childList={environments}
                  // label={<span style={{display:"flex",alignItems:"center"}} title="E.g. Production is PR, Development is DV">Environment <Icon
                  // alt="alt value"
                  // className="icon $color-icon small material-icons-outlined ml-1"
                  // icon="info"
                  // size="small"
                  // style={{fontSize:"12px"}} />
                  // </span>}
                  selection="single"
                  isClearable
                  isRequired
                  showLabelIcon={false}
                  menuPosition="bottom-right"
                  size="medium"
                  selectedValue={field.value}

                  // If your Dropdown exposes setSelectedValue, bridge it to RHF:
                  setSelectedValue={(val) => {
                    field.onChange(val);
                  }}

                  // Nice-to-have wiring if supported by your component:
                  onBlur={field.onBlur}
                  inputRef={field.ref}

                  // Show validation message from RHF:
                  helperText={fieldState.error?.message ?? ''}
                  isInvalid={!!fieldState.error}
                  className="safe-name-dropdown"
                  placeholder="Select Environment"
                  onKeyDown={(e) => e.preventDefault()}
                />
              )}
            />
            </div>

            <div className="form-field">
            <div style={{marginBottom:"-13px"}}>
              <label className="safe-name"><span title="Abbreviation of application name for these accounts, preferably three characters and max 10 charecters" style={{display:"flex",alignItems:"center", width: "calc(100% - 60px)"}}>Short Name of the application <Icon
                alt="alt value"
                className="$color-icon-default ml-1"
                icon="info"
                size="small"
                style={{fontSize:"12px"}} /></span></label>
            </div>
            
            {/* <Controller
              name="appName"
              control={control}
              rules={{
              required: t("App name is required"),
              maxLength: {
                value: 10,
                message: "Maximum 10 characters allowed"
              },
              
              pattern: {
                value: /^[A-Za-z0-9_]+$/,
                message: "Only letters, numbers, and underscore (_) are allowed",
              },
              
              }}
              render={({ field,fieldState }) => (
              <TextInput
                type="text"
                className="input-margin-top-bottom-0"                
                
                onChange={(e) => {
                  const cleaned = (e.target.value || "").replace(/[^A-Za-z0-9_]/g, "");
                  field.onChange(cleaned);
                  setValue1(cleaned);
                }}

                required={true}
                maxLength={10}
                value={(value1 || "").replace(/[^A-Za-z0-9_]/g, "")}
                // onChange={handleChange}
                // label={t("Short Name of the application")}
                // value ={prefixValue}
                // onChange={handleChange}
                // prefix="ap-pr-"
                // aria-invalid={!!errors.appName}
                helperText={fieldState.error?.message ?? ""}
                style={{ width: "100%" }}
              />
            )}
              /> */}
              <Controller
                  name="appName"
                  control={control}
                  rules={{
                    required: t("App name is required"),
                    maxLength: { value: 10, message: "Maximum 10 characters allowed" },
                    pattern: {
                      value: /^[A-Za-z0-9_]+$/,
                      message: "Only letters, numbers, and underscore (_) are allowed",
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const allowed = /^[A-Za-z0-9_]$/;
                    const sanitize = (v = "") => String(v).replace(/[^A-Za-z0-9_]/g, "");

                    return (
                      <TextInput
                        {...field}
                        value={field.value ?? ""}
                        maxLength={10}
                        required
                        helperText={fieldState.error?.message ?? ""}
                        className="input-margin-top-bottom-0"
                        style={{ width: "100%" }}
                        onBeforeInput={(e) => {
                          const data = e?.data ?? "";
                          if (data && !allowed.test(data)) {
                            e.preventDefault();
                          }
                        }}
                        onKeyDown={(e) => {
                          const k = e.key;
                          if (
                            e.ctrlKey || e.metaKey ||
                            ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"].includes(k)
                          ) return;
                          if (k.length === 1 && !allowed.test(k)) {
                            e.preventDefault();
                          }
                        }}

                        onChange={(e) => {
                          const raw = e?.target?.value ?? "";
                          field.onChange(sanitize(raw));
                        }}

                        onPaste={(e) => {
                          e.preventDefault();
                          const pasted = e.clipboardData.getData("text");
                          const cleaned = sanitize(pasted).slice(0, 10);
                          field.onChange(cleaned);
                          if (e.target) e.target.value = cleaned;
                        }}
                      />
                    );
                  }}
                />

              {appName?.length > 10 && (
                <span style={{color:"red"}}>App Name Should be max of 10 characters</span>
              )}
            </div>
          </>
        )}
        <div style={{marginTop:"4px",justifyContent:"space-between"}} className="d-flex">
          <label className="safe-name" title="Members that need access to accounts in the safe" style={{display:"flex",alignItems:"center"}}>Safe Members <Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined ml-1"
                icon="info"
                size="small"
                style={{fontSize:"12px"}} /></label>
          <label className="required-text $font-xsmall-regular" style={{color:"var(--color-text-secondary)"}}>*Required</label>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'5px'}}>
        <Controller          
            name="safeMembers"
            control={control}
            defaultValue={null}
            rules={{
              
            }}
            render={({ field, fieldState }) => (
            <Search
              isAutoComplete
              isClearable={queryGPID?.length>0}
              onClear={()=>{clearUsers();field.onChange(null);setQueryGPID("");}}
              maxLength={30}
              value={queryGPID}
              isDisabled={disableGpidSearch}
              onSelectOption={(val) =>{
                // gpidSerach(val)
                // setSelectedUser(val);
                addToSafeMembers(val);
                setQueryGPID("");
                // setSelectedUser("");
                setUsers([]);
              }}
              onSearch={(event) => gpidSerach(event)}
              onUpdate={(text)=>{
                setQueryGPID(text);
                debouncedSearchGPID(text);
                }}
              placeholderText="Search with GPID/Email to add members to safe"
              size="medium"
              style={{width:'100%'}}
              autoComplete="off"
              suggestions={users}
              delay={0}
              limitSuggestions={50}
            />
          )}
        />
        {/* <Icon
          alt="alt value"
          className="icon $color-icon small material-icons-outlined ml-1"
          icon="add_box"
          size="medium"
          onClick={()=>addToSafeMembers(selectedUser)}
          style={{width:'5%'}}
        /> */}
        </div>
        {safeOwners.length > 0 && <div>
        <label className="safe-name">Safe Owner</label>
        <div className="accountsAlign">
          {safeOwners?.map((acc, index) => (
            <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "}</span>
          ))}
        </div>
        </div> 
        }
        {safeMembers.length > 0 && <div className="mb-1">
        <label className="safe-name">Safe Members</label>
        <div className="accountsAlign">
          {safeMembers?.map((acc, index) => (
            <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "} 
          {!safeOwners?.some(owner => owner.id === acc?.id) &&  
            <Icon
            alt="alt value"
            className="icon $color-icon small material-icons-outlined ml-1"
            icon="close"
            size="small"
            onClick={()=>removeFromSafeMembers(acc?.id)}
            style={{color:'white',cursor:"pointer"}}
          />
          }
          {" "}</span>
          ))}
        </div>
        </div> 
        }
        {/* <div className="form-field">
        <Controller
          name="fullAppName"
          control={control}
          rules={{ required: t('Application name is required'),
            // validate: (v) => (v ? true : 'Please select an application from the list'),
           }} 
          render={({ field }) => (
        <Search
          isAutoComplete
          isClearable={true}
          onClear={setSelectedApp('')}
          onSelectOption={(val) =>{
            setSelectedApp(val)
          }
          }
          onSearch={(val)=>searchApplications(val)}
          required={true}
          onUpdate={(text) => {
            setQuery(text);
            debouncedSearch(text);
          }}

          placeholderText="Search for an application"
          size="medium"
          autoComplete="off"
          suggestions={applications}
        />
        )}
        />
          
        </div> */}
        
        <div className="form-field">
        <div style={{display:'flex',justifyContent:"space-between"}}>
        <label className="safe-name" title="Full application name using these accounts" style=       {{display:"flex",alignItems:"center"}}>Application <Icon
            alt="alt value"
            className="icon $color-icon small material-icons-outlined ml-1"
            icon="info"
            size="small"
            style={{fontSize:"12px"}} />
        </label>
        <label className="required-text $font-xsmall-regular" style={{color:"var(--color-text-secondary)"}}>*Required</label>
        </div>
          <Controller          
            name="fullAppName"
            control={control}
            defaultValue={null}
            rules={{
              required: t("Application name is required"),
              validate: (v) => {
                const sel = normalizeSel(v);
                return sel ? true : t("Please select an application from the list");
              },
            }}
            render={({ field, fieldState }) => (
              <>
              <Search
                isAutoComplete
                isClearable={true}
                required
                isRequired
                maxLength={20}
                isDisabled={disableAppSearch}
                onClear={() => {
                  setSelectedApp(null);
                  field.onChange(null);
                }}
                onSelectOption={(val) => {
                  const sel = Array.isArray(val) ? val[0] : val;
                  setSelectedApp(sel);
                  field.onChange(sel);
                }}
                onSearch={(val) => searchApplications(val)}
                onUpdate={(text) => {
                  setQuery(text.trimStart());
                  debouncedSearch(text); //debounce
                }}
                placeholderText="Search for an Application(Minimun 3 Characters)"
                size="medium"
                autoComplete="off"
                suggestions={applications}
                selectedValue={field.value}
                errorText={fieldState.error?.message}
                limitSuggestions={50}
                searchTerm={query}
              />
              {fieldState?.error && <div className="feedback $font-xsmall-regular info dropdown-hint $spacing-mt03 medium"><Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined"
                icon="info"
                size="small"
                style={{}}
              />{fieldState?.error?.message}</div>
            }
              </>
            )}
          />
        </div>

        {/* Existing Password */}
        <div className="form-field mb-1">
        <div className="safe-name" style={{marginBottom:"-13px"}}>
          <label title="Current working password for this account" style={{display:"flex",alignItems:"center", width: "calc(100% - 60px)"}}>{"Existing " + accountNames[0]?.displayText + '/' +domains[0]?.displayText+" Password"} <Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined ml-1"
                icon="info"
                size="small"
                style={{fontSize:"12px"}}
          />
          </label>
        </div>
        <Controller
          name="existingPassword"
          control={control}
          defaultValue=""
          rules={{ required: t('Existing Password is required'),
            validate: (v) => (v ? true : 'Please select an application from the list'),
           }} 
          render={({ field, fieldState }) => (
          <TextInput
            type={passwordType}
            value={field.value ?? ""}
            maxLength={30}            
            onChange={(e) => {
              setIsPasswordValid(null);
              field.onChange(e.target?.value ?? e);
            }}
            required ={true}
            // label={}
            // onPaste={(e) => e.preventDefault()}
            className="input-margin-top-bottom-0"
            onBlur={field.onBlur}
            helperText={fieldState.error?.message ?? ""}
            style={{ width: "100%" }}
          />
          )}
          />
          <div
            className="flex justify-around items-center "
            id="hide-icon"
            onClick={handleToggle}
          >
            <Icon
                alt="alt value"
                icon={icon}
                size="18px"
                style={{ marginTop: "-31px",marginRight:isArabic?"-32px":"8px", marginLeft:isArabic? "":"auto", zIndex:1,fontSize:'21px' }}
            />
            
          </div>
          {isPasswordValid && 
          <span className="safe-name" style={{color:"green",display:"flex",alignItems:"center"}}><Icon
            alt="alt value"
            className="icon $color-icon small material-icons-outlined ml-1"
            icon="check_circle"
            size="small"
            style={{fontSize:"12px"}}
          /> Password is Verified
          </span>
          }
          {isPasswordValid == false && (
          <span className="safe-name" style={{color:"red",display:"flex",alignItems:"center"}}><Icon
            alt="alt value"
            className="icon $color-icon small material-icons-outlined ml-1"
            icon="cancel"
            size="small"
            style={{fontSize:"12px"}}
          />  Password is incorrect.
          </span>
          )}
          
        </div>
        <div className="form-field">
        <div className="safe-name" style={{marginBottom:"-13px"}}>
          <label title="Please re-type the password for this account" style={{display:"flex",alignItems:"center", width: "calc(100% - 60px)"}}>{"Retype " + accountNames[0]?.displayText + '/' + domains[0]?.displayText+" Password"} <Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined ml-1"
                icon="info"
                size="small"
                style={{fontSize:"12px"}}
          />
          </label>
        </div>
        <Controller
          name="existingRetypePassword"
          control={control}
          rules={{ 
            required: t("Existing Retype Password is required"),              
          validate: (value) => {
            if (!value) return true;

            return value === existingPasswordValue || "Passwords do not match";
          },

          }}
          render={({ field, fieldState }) => (
          <TextInput
            type={rePasswordType}
            maxLength={30}
            value={field.value ?? ""}  
            // {...register('existingRetypePassword', {
            //   // required: t("Existing Retype Password is required"),
            //   validate: (value) =>
            //     value === existingPassword || 'Passwords do not match',
            // })}

            required={true}
            onChange={(e) => {
              field.onChange(e.target?.value ?? e);
            }}
            // label={"Retype " + accountNames[0]?.displayText + '/' + domains[0]?.displayText+" Password"}
            // onPaste={(e) => e.preventDefault()}
            className="input-margin-top-bottom-0"
            helperText={fieldState.error?.message ?? ""}
            onBlur={field.onBlur}
            style={{ width: "100%" }}
          />
          )}
          />
          <div
            className="flex justify-around items-center "
            id="hide-icon"
            onClick={handleToggleRetypePassword}
          >
            <Icon
                alt="alt value"
                icon={reTypeIcon}
                size="18px"
                style={{ marginTop: "-31px",marginRight:isArabic?"-32px":"8px", marginLeft:isArabic? "":"auto", zIndex:1,fontSize:'21px' }}
            />
            
          </div>
          <span className="safe-name" style={{color:"red",display:"flex",alignItems:"center"}}>{existingRetypePassword !== existingPassword ? "Password and Retype password should match":""}
          </span>
        </div>
        {existingPassword == existingRetypePassword && existingPassword.length > 0 &&  
        <div className="safename" style={{display:'ruby',
          fontSize:"12px",color:"#616161",
        }}>
          
          <span>
            Please click here to
          </span>
        
          <Button
            type="button"
            onClick={ValidatePassword}
            disabled={submitValidatePassword}
            size="small"
            style={{
              fontSize: "12px",
              padding: "0 4px"
            }}
            text="Validate Password"
            variant="tertiary"
          />
        
          <span >
            first – This will enable the Submit button!
          </span>
        
        </div>
        }
        {/* Safe members (full row) */}
        {/* <div className="form-field full-row">
          <TextArea
            label={t("Safe members")}
            placeholder={t("Enter comma separated GPIDs of Safe members")}
            showCharacterCount
            showToolbar={false}
            showLabelIcon={false}
            {...register("safeMembers")}
            className=""
            style={{ width: "100%" }}
          />

        </div> */}
      </div>

      {/* Actions */}
      <div className="form-actions" style={{justifyContent:"flex-start"}}>
        <div></div>
        <div>
          <Button
            variant="primary" 
            type="submit"
            size="medium"
            disabled={!isPasswordValid || !isValid || isSubmitting}
            >
            {t("Submit")}
          </Button>
          {/* 
          <Button
            type="button"
            size="medium"
            className="secondary-button"
            onClick={() => reset()}
            disabled={!isDirty || isSubmitting}
          >
            {t("Reset")}
          </Button> 
          */}
          
        </div>
        
      </div>
      
    </form>
  </Sidepanel>
  </div>
  {/* Change Account Owner */}
  <div>
  <Sidepanel
    className=""
    linkProps={{
      iconLeading: '',
      iconTrailing: 'arrow_forward',
      label: 'Link',
      onClick: function ERe(){},
      size: 'medium'
    }}
    onCloseSidePanel={(event)=>{console.log('1212121212',event);
      if(event.type == 'mousedown' || event.type == "mouseup"){
        event.preventDefault();
        return;
      };
      setShowChangeOwnerSidePanel(false);setUsers([]);resetAllForm();}}
    primaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Submit',
      variant: 'primary'
    }}
    showSidePanel={showChangeOwnerSidePanel}
    secondaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Cancel',
      variant: 'secondary'
    }}
    showFooter = {false}
    showLink ={false}
    showSecondaryButton
    showTertiaryButton ={false}
    style={{}}
    closeOnOutsideClick={false}
    tertiaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Button',
      variant: 'tertiary'
    }}
    
    title={"Account Name : " + accountNames[0]?.displayText + "[" + domains[0]?.displayText + "]"}
    type="vertical"
    verticalSidepanelHeight="40% !important"
  >
    <form
      className="form-size pro-form pb-3"
      onSubmit={handleSubmit(onSubmitChangeOwner,(errs) => {
          console.warn('Submit blocked by validation:', errs);
        })}
    >
      <div className="form-grid">
        
        {/* <div style={{display:'flex',alignItems:'center',gap:'5px'}}>
        <Search
          isAutoComplete
          isClearable
          onClear={()=>clearUsers()}
          onSelectOption={(val) =>{
            gpidSerach(val)
            setSelectedUser(val);
          }}
          onSearch={(event) => gpidSerach(event)}
          onUpdate={(text)=>{
            setQueryGPID(text);
            debouncedSearchGPID(text);
            }}
          placeholderText="Search a GPID to add members to safe"
          size="medium"
          style={{width:'95%'}}
          autoComplete="off"
          suggestions={users}
        />
        <Icon
          alt="alt value"
          className="$color-icon-default"
          icon="add_box"
          size="medium"
          onClick={()=>addToSafeMembers(selectedUser)}
          style={{width:'5%'}}
        />
        </div> */}
        {selectedAccount?.description?.length > 0 && 
        <div className="form-field">
        <TextArea
          label={t("Description")}
          value={selectedAccount?.description}
          readOnly={true}
          showCharacterCount
          showToolbar={false}
          showLabelIcon={false}
          className=""
          style={{ maxWidth: "100%",opacity: "0.6"  }}
        />
        </div>
        }
        <div className="form-field">
        <label className="safe-name">New Account Owner</label>
          <Controller          
            name="ownerGpid"
            control={control}
            defaultValue={null}
            rules={{
              required: t("GPID is required"),
              validate: (v) => {
                const sel = normalizeSel(v);
                return sel ? true : t("Please select an GPID from the list");
              },
            }}
            render={({ field, fieldState }) => (
              <>
              <Search
                isAutoComplete
                isClearable={true}
                onClear={() => {
                  setSelectedGpid(null);
                  field.onChange(null);
                }}
                onSelectOption={(val) => {
                  const sel = Array.isArray(val) ? val[0] : val;
                  setSelectedGpid(sel);
                  field.onChange(sel);
                }}
                isDisabled={disableGpidSearch}
                onSearch={(val) => debouncedSearchGPID(val)}
                onUpdate={(text) => {
                  setQuery(text);
                  debouncedSearchGPID(text); //debounce
                }}
                placeholderText="Search with GPID/Email"
                size="medium"
                autoComplete="off"
                suggestions={users}
                selectedValue={field.value}
                errorText={fieldState.error?.message}
                limitSuggestions={50}
              />
              {fieldState?.error && <div className="feedback $font-xsmall-regular info dropdown-hint $spacing-mt03 medium"><Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined ml-1"
                icon="info"
                size="small"
                style={{}}
              />{fieldState?.error?.message}</div>
            }
              </>
            )}
          />
        </div>
       
      </div>

      {/* Actions */}
      <div className="form-actions">
        <div></div>
        <div>
          <Button
            variant="primary" 
            type="submit"
            size="medium"
            disabled={!isValid || isSubmitting}
            >
            {t("Submit")}
          </Button>
          
        </div>
        
      </div>
      
    </form>
  </Sidepanel>

</div>
    <ToastContainer
      position="bottom-center"
      data={toasts}
      removeToast={removeToast}
    />
  </div>
  );
};

export default SvcAccountRequest;
